var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxWalletOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 10.422V12.1144C12.2344 12.3388 12.1452 12.554 11.9865 12.7127C11.8277 12.8713 11.6124 12.9605 11.3879 12.9605H3.34647C3.12197 12.9605 2.90667 12.8713 2.74792 12.7127C2.58918 12.554 2.5 12.3388 2.5 12.1144V5.7682C2.5 4.36625 3.63693 3.22974 5.0394 3.22974H10.5414V5.34512",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0763 7.88379H10.1145C9.88084 7.88379 9.69141 8.07321 9.69141 8.30687V9.99917C9.69141 10.2328 9.88084 10.4223 10.1145 10.4223H13.0763C13.31 10.4223 13.4994 10.2328 13.4994 9.99917V8.30687C13.4994 8.07321 13.31 7.88379 13.0763 7.88379Z",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.232 7.88392V6.19161C12.232 5.9672 12.1428 5.75198 11.9841 5.59329C11.8255 5.43461 11.6102 5.34546 11.3858 5.34546H10.5395H5.03906",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxWalletOutline);
export default __webpack_public_path__ + "static/media/icon_16px_wallet_outline.76e060871b1a45932a8a7c626ffe4351.svg";
export { ForwardRef as ReactComponent };